<template>
  <div class="page-wrapper">
    <Tabs value="name1" :animated=false>
      <TabPane label=" 当日GOP" name="name1">
        <gop :projectList="projectList"></gop>
      </TabPane>
      <TabPane label="业绩提佣" name="name2">
        <yeji :projectList="projectList"></yeji>
      </TabPane>
        <TabPane label="商机成交" name="name3" v-if="mp('businessdeal')">
             <business-deal ></business-deal>
        <!-- <yeji :projectList="projectList"></yeji> -->
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import Gop from './components/Gop'
  import Yeji from './components/Yeji'
  import {getProjects} from "../../../../api/common";
  import businessDeal from '../../rent/components/businessDeal/index';
import { mixin } from "../../../../mixin";
  export default {
    name: "commissionboard",
    mixins: [mixin],
    components:{
     Gop,
      Yeji,
      businessDeal
    },
    data(){
      return {
        projectList:[]
      }

    },
    created() {
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data

      }).catch(error => {
      })

    }

  }
</script>

<style scoped>

</style>
